var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Information Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-28.000000, -217.000000)",
    fill: "#4A5866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Information-Icon",
    transform: "translate(28.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6356,5.9388 L9.3324,5.9388 L9.3324,4.242 L7.6356,4.242 L7.6356,5.9388 Z M8.484,12.726 C8.01738,12.726 7.6356,12.34422 7.6356,11.8776 L7.6356,8.484 C7.6356,8.01738 8.01738,7.6356 8.484,7.6356 C8.95062,7.6356 9.3324,8.01738 9.3324,8.484 L9.3324,11.8776 C9.3324,12.34422 8.95062,12.726 8.484,12.726 L8.484,12.726 Z M8.484,0 C3.800832,0 0,3.800832 0,8.484 C0,13.167168 3.800832,16.968 8.484,16.968 C13.167168,16.968 16.968,13.167168 16.968,8.484 C16.968,3.800832 13.167168,0 8.484,0 L8.484,0 Z",
    transform: "translate(8.484000, 8.484000) rotate(-180.000000) translate(-8.484000, -8.484000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsLight);
export default __webpack_public_path__ + "static/media/alerts-light.ed9ab654374cfd482079204b82ab3d76.svg";
export { ForwardRef as ReactComponent };